module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-list clearfix"
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [_c('list-header'), _vm._v(" "), (_vm.boxes.length > 0) ? _c('ul', {
    staticClass: "kp-list-item"
  }, _vm._l((_vm.boxes), function(box, index) {
    return _c('item', {
      attrs: {
        "box": box,
        "index": index
      }
    })
  }), 1) : _c('empty')], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7957d8d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/Main.vue
 ** module id = 869
 ** module chunks = 1
 **/